import { Table, Tag } from "antd";
import React from "react";
import style from "../style";
import dayjs from "dayjs";
import { useRequisitionBranchContext } from "../context";

const STATUS_TAG = { available: "orange", used: "green", void: "red" };

const TableComponent = () => {
  const { state, fetchData, dispatch } = useRequisitionBranchContext();

  const createColumn = (column) => ({
    ...column,
    align: "center",
    onHeaderCell: () => ({ style: style.table.table_cell }),
  });
  const columns = [
    createColumn({
      title: "#",
      key: "row_id",
      dataIndex: "row_id",
      width: 80,
    }),
    createColumn({
      title: "รหัสโค้ด",
      dataIndex: "code",
      key: "code",
      width: 120,
    }),
    createColumn({
      title: "สถานะ",
      dataIndex: "status_text",
      key: "status_text",
      width: 120,
      render: (text, record) => (
        <Tag color={STATUS_TAG[record.status]}>{text}</Tag>
      ),
    }),
    createColumn({
      title: "วันที่ใช้โค้ด",
      dataIndex: "used_date",
      key: "used_date",
      width: 110,
      render: (text) => (text ? dayjs(text).format("DD/MM/YYYY") : ""),
    }),
    createColumn({
      title: "วันหมดอายุ",
      dataIndex: "end_date",
      key: "end_date",
      width: 110,
      render: (text) => {
        if (!text) return "";
        const days = dayjs(text)
          .startOf("day")
          .diff(dayjs().startOf("day"), "day");
        return (
          <>
            {dayjs(text).format("DD/MM/YYYY")}
            <div>{days >= 0 ? `เหลืออีก ${days} วัน` : "หมดอายุแล้ว"}</div>
          </>
        );
      },
    }),
    createColumn({
      title: "ชื่อ - สกุล ผู้ใช้โค้ด",
      dataIndex: "user_name",
      key: "user_name",
      width: 270,
    }),
    createColumn({
      title: "เบอร์โทรผู้ใช้โค้ด",
      dataIndex: "user_phone",
      key: "user_phone",
      width: 125,
    }),
    createColumn({
      title: "อีเมลผู้ใช้โค้ด",
      dataIndex: "user_email",
      key: "user_email",
      width: 125,
    }),
    createColumn({
      title: "องค์กร (ผู้สั่งซื้อ)",
      dataIndex: "owner_team",
      key: "owner_team",
      width: 105,
    }),
    createColumn({
      title: "รหัส-นักธุรกิจ (ผู้สั่งซื้อ)",
      dataIndex: "owner_partner_code",
      key: "owner_partner_code",
      width: 185,
    }),
    createColumn({
      title: "ชื่อ-นักธุรกิจ (ผู้สั่งซื้อ)",
      dataIndex: "owner_name",
      key: "owner_name",
      width: 230,
    }),
    createColumn({
      title: "วันที่สั่งซื้อ",
      dataIndex: "document_date",
      key: "document_date",
      width: 110,
      render: (text) => dayjs(text).format("DD/MM/YYYY"),
    }),
    createColumn({
      title: "เลขที่ใบเสร็จ",
      dataIndex: "document_no",
      key: "document_no",
      width: 135,
    }),
  ];
  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={state.data?.list || []}
      bordered
      scroll={{
        x: 1800,
      }}
      onChange={(pagination) => {
        const { current, pageSize } = pagination;
        const offset = (current - 1) * pageSize;

        const filters = {
          ...state.filters,
          limit: pageSize,
          offset,
        };

        dispatch({
          type: "SET_FILTERS",
          payload: {
            limit: pageSize,
            offset,
          },
        });

        fetchData(filters);
      }}
      pagination={{
        current: Math.floor(state.filters.offset / state.filters.limit) + 1,
        pageSize: state.filters.limit,
        total: state.data?.total || 0,
        showSizeChanger: true,
      }}
    />
  );
};

export default TableComponent;
